import { render, staticRenderFns } from "./RolesEdit.vue?vue&type=template&id=3f22c8c4&scoped=true"
import script from "./RolesEdit.vue?vue&type=script&lang=js"
export * from "./RolesEdit.vue?vue&type=script&lang=js"
import style0 from "./RolesEdit.vue?vue&type=style&index=0&id=3f22c8c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f22c8c4",
  null
  
)

export default component.exports